import { useTheme } from '@emotion/react';
import { AnimatePresence, motion } from 'framer-motion';

import { getIconSizeInRem, IconProps } from './icon';

interface Props {
    isVisible: boolean;
    initial?: boolean;
    color?: IconProps['color'];
    size?: IconProps['size'];
}

export const AnimatedCheckIcon = ({
    color,
    isVisible,
    initial = true,
    size = 'medium',
}: Props) => {
    const { palette } = useTheme();

    return (
        <AnimatePresence initial={initial}>
            {isVisible && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth={1.5}
                    stroke={color || palette.common.black}
                    height={getIconSizeInRem(size)}
                    width={getIconSizeInRem(size)}
                >
                    <motion.path
                        initial={{ pathLength: 0 }}
                        animate={{ pathLength: 1 }}
                        exit={{ pathLength: 0 }}
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        d='M4.5 12.75l6 6 9-13.5'
                        transition={{
                            type: 'tween',
                            duration: 0.3,
                            ease: isVisible ? 'easeOut' : 'easeIn',
                        }}
                    />
                </svg>
            )}
        </AnimatePresence>
    );
};
